import {useNavigate} from 'react-router-dom';

const useNavigationLink=(key, value)=>{
    const navigate = useNavigate();
    const open = ()=>{
        let params = new URLSearchParams(location.search);
        params.set(key, value);
        navigate({
            search: params.toString()
        });
    };

    const close = (key)=>{
        let params = new URLSearchParams(location.search);
        params.delete(key);
        navigate({
            search: params.toString(),
        }, {replace: true});
    };
    return {open, close};
};
export default useNavigationLink;